(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-menu"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', () => {
		const DESKTOP_BREAKPOINT = '(min-width: 800px)';
		const desktopQuery = window.matchMedia(DESKTOP_BREAKPOINT);
		const panels = document.querySelectorAll('.footer-v2-menu__links');

		function syncPanelVisibility(isDesktop) {
			panels.forEach((panel) => {
				if (isDesktop) {
					panel.removeAttribute('hidden');
					return;
				}

				const column = panel.closest('.footer-v2-menu__column');
				const toggle = column?.querySelector('[data-footer-v2-toggle]');
				const isExpanded = toggle?.getAttribute('aria-expanded') === 'true';

				if (isExpanded) {
					panel.removeAttribute('hidden');
				} else {
					panel.setAttribute('hidden', '');
				}
			});
		}

		syncPanelVisibility(desktopQuery.matches);
		desktopQuery.addEventListener('change', (event) => {
			syncPanelVisibility(event.matches);
		});

		document.querySelectorAll('[data-footer-v2-toggle]').forEach((button) => {
			button.addEventListener('click', () => {
				const targetId = button.dataset.footerV2Toggle;
				const target = document.getElementById(targetId);
				const isExpanded = button.getAttribute('aria-expanded') === 'true';
				const nowExpanded = !isExpanded;

				button.setAttribute('aria-expanded', String(nowExpanded));
				target.classList.toggle('footer-v2-menu__links--active');

				if (nowExpanded) {
					target.removeAttribute('hidden');
				} else {
					target.setAttribute('hidden', '');
				}
			});
		});
	});
  } catch(e) { console.error(e); }
})();

})();
